import React from 'react';
import _ from 'lodash';
import { ERROR_WRONG_INFORMATIONS, ERROR_ADD_DEEPLINK, SUCCESS_UPDATE_TEXT, ERROR_GETTING_DEEPlINKS_ANALYTICS, BRANCH_EVENTS, ANALYTICS_TYPES } from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import { addNewDeepLink, getDeepLinksAnalytics } from '../../apis/backend';
import { showNotification } from '../Notification/Notification.view';
import moment from 'moment';
type DeepLink = {
    campaign: string;
    channel: string;
    creationDate: Date;
};
type DeepLinks = Record<string, DeepLink>;

type DeepLinkAnalytics = {
    eventType: string;
    count: number;
    bottom: number;
};



export const handleToggle = async (
    setExpandedDeepLinks: React.Dispatch<React.SetStateAction<any>>,
    id: string,
    deepLinks: DeepLinks,
    startDate: Date,
    endDate: Date,
    setDeepLinksAnalytics: React.Dispatch<React.SetStateAction<any>>,
    setIsLoadingAnalytics: React.Dispatch<React.SetStateAction<any>>,
    openErrorModal: (message: string) => void,
    firstTime: boolean,
    setOpenedDeepLink: React.Dispatch<React.SetStateAction<any>>
): Promise<void> => {
    if (!firstTime) {
        setDeepLinksAnalytics([]);
    }
    const { campaign, channel, creationDate } = deepLinks[id];
    const newExpandedDeepLinks = _.reduce(deepLinks, (acc: Record<string, boolean>, _, key) => {
        acc[key] = key === id;
        return acc;
    }, {});
    setOpenedDeepLink(deepLinks[id])
    setExpandedDeepLinks(newExpandedDeepLinks);
    await getAnalytics(campaign, channel, startDate, endDate, setIsLoadingAnalytics, setDeepLinksAnalytics, openErrorModal, creationDate);
};


export const copyLink = (link: string): void => {
    navigator.clipboard.writeText(link);
};

export const handleChangeTypes = (
    event: React.ChangeEvent<HTMLInputElement>,
    setChannel: React.Dispatch<React.SetStateAction<any>>
): void => {
    const { value } = event.target;
    setChannel(value);
};


export const addDeepLink = async (
    campaign: string,
    channel: string,
    setIsLoading: React.Dispatch<React.SetStateAction<any>>,
    openErrorModal: (message: string) => void,
    setIsOpen: React.Dispatch<React.SetStateAction<any>>,
    setChannel: React.Dispatch<React.SetStateAction<any>>,
    setCampaign: React.Dispatch<React.SetStateAction<any>>,
    setIsAddDeepLink: React.Dispatch<React.SetStateAction<any>>
): Promise<void> => {
    try {
        setIsLoading(true);
        if (campaign && channel) {
            await addNewDeepLink(campaign, channel);
            closeModal(setIsOpen, setChannel, setCampaign);
            setIsLoading(false);
            showNotification(
                'light',
                'ltr',
                'primary',
                SUCCESS_UPDATE_TEXT,
                `Ce lien magique a bien été ajouté`
            );
            setIsAddDeepLink(true);
        } else {
            openErrorModal(ERROR_WRONG_INFORMATIONS);
        }
    } catch (error) {
        sendCloudWatchAlert(`Error adding deep link: ${error}`);
        openErrorModal(ERROR_ADD_DEEPLINK);
    }
    setIsLoading(false);
};

export const closeModal = (
    setIsOpen: React.Dispatch<React.SetStateAction<any>>,
    setChannel: React.Dispatch<React.SetStateAction<any>>,
    setCampaign: React.Dispatch<React.SetStateAction<any>>
): void => {
    setIsOpen(false);
    setChannel('');
    setCampaign('');
};
export const extractEventCounts = (analytic: { eventDetails: any[] }, eventType): DeepLinkAnalytics[] => {
    const eventCounts: Record<string, number> = {
        click: 0,
        open: 0,
        install: 0,
        complete_registration: 0,
        purchase: 0,
        reinstall: 0
    };

    const { eventDetails = [] } = analytic;
    const getEventData = (elm: string) => eventDetails.find(event => event.eventType === elm) || {};


    switch (eventType) {
        case ANALYTICS_TYPES.HAS_NOT_APPLICATION:
            eventCounts[BRANCH_EVENTS.CLICK] += getEventData(BRANCH_EVENTS.CLICK).totalUsers || 0;
            eventCounts[BRANCH_EVENTS.OPEN] += getEventData(BRANCH_EVENTS.OPEN).totalInstall || 0;
            eventCounts[BRANCH_EVENTS.INSTALL] += getEventData(BRANCH_EVENTS.INSTALL).totalUsers || 0;
            eventCounts[BRANCH_EVENTS.REINSTALL] += getEventData(BRANCH_EVENTS.REINSTALL).totalUsers || 0;
            eventCounts[BRANCH_EVENTS.REGISTRATION] += getEventData(BRANCH_EVENTS.REGISTRATION).totalRegisteredAfterInstall || 0;
            eventCounts[BRANCH_EVENTS.PURCHASE] += getEventData(BRANCH_EVENTS.PURCHASE).purchasedAfterRegistrationWithFirstTimeInstall +
                getEventData(BRANCH_EVENTS.PURCHASE).purchasedWithoutRegistrationWithFirstTimeInstall + getEventData(BRANCH_EVENTS.PURCHASE).purchasedAfterRegistrationWithReInstall + getEventData(BRANCH_EVENTS.PURCHASE).purchasedWithoutRegistrationWithReInstall || 0;
            break;

        case ANALYTICS_TYPES.ACCEPT_NEWSLETTER:
            eventCounts[BRANCH_EVENTS.REGISTRATION] += getEventData(BRANCH_EVENTS.REGISTRATION).totalSignedUpUsers || 0;
            eventCounts[BRANCH_EVENTS.NEWSLETTER] = getEventData(BRANCH_EVENTS.REGISTRATION).totalNewsletterSubscribers || 0;
            break;

        case ANALYTICS_TYPES.HAS_NOT_ACCOUNT:
            eventCounts[BRANCH_EVENTS.CLICK] += getEventData(BRANCH_EVENTS.CLICK).totalUsers || 0;
            eventCounts[BRANCH_EVENTS.OPEN] += getEventData(BRANCH_EVENTS.OPEN).hasAppAlready || 0;
            eventCounts[BRANCH_EVENTS.REGISTRATION] += getEventData(BRANCH_EVENTS.REGISTRATION).registeredWithoutInstall || 0;
            eventCounts[BRANCH_EVENTS.PURCHASE] += getEventData(BRANCH_EVENTS.PURCHASE).purchasedAfterRegistrationWithoutInstall || 0;
            break;

        case ANALYTICS_TYPES.HAS_ACCOUNT:
            eventCounts[BRANCH_EVENTS.CLICK] += getEventData(BRANCH_EVENTS.CLICK).totalUsers || 0;
            eventCounts[BRANCH_EVENTS.OPEN] += getEventData(BRANCH_EVENTS.OPEN).hasAppAlready || 0;
            eventCounts[BRANCH_EVENTS.PURCHASE] += getEventData(BRANCH_EVENTS.PURCHASE).purchasedWithoutRegistrationWithoutInstall || 0;
            break;
    }
    eventCounts.install += eventCounts.reinstall;
    const result = Object.entries(eventCounts).map(([type, count]) => ({
        eventType: type,
        count,
        bottom: 0,
    }));

    return result.filter(elm => elm.eventType !== BRANCH_EVENTS.REINSTALL);
};


export const getAnalytics = async (
    campaign: string,
    channel: string,
    startDate: Date,
    endDate: Date,
    setIsLoadingAnalytics: React.Dispatch<React.SetStateAction<any>>,
    setDeepLinksAnalytics: React.Dispatch<React.SetStateAction<any>>,
    openErrorModal: (message: string) => void,
    creationDate: Date
): Promise<void> => {
    try {
        const deepLinkCreationDate = moment(creationDate).toISOString().split('.')[0];
        const deepLinkStartDate = moment(startDate).toISOString().split('.')[0];
        setIsLoadingAnalytics(true);
        const deepLinksAnalytics = await getDeepLinksAnalytics(campaign, channel, startDate, endDate, deepLinkCreationDate === deepLinkStartDate);
        setIsLoadingAnalytics(false);
        setDeepLinksAnalytics(deepLinksAnalytics);
    } catch (error) {
        sendCloudWatchAlert(`Error getting deep link analytics: ${error}`);
        openErrorModal(ERROR_GETTING_DEEPlINKS_ANALYTICS);
        setIsLoadingAnalytics(false);
    }
};


export const onSelectDate = async (ranges: any, setDateRange: React.Dispatch<React.SetStateAction<any>>, id: any, setIsLoadingAnalytics: React.Dispatch<React.SetStateAction<any>>, setDeepLinksAnalytics: React.Dispatch<React.SetStateAction<any>>, openErrorModal: React.Dispatch<React.SetStateAction<any>>, setExpandedDeepLinks, deepLinks, setOpenedDeepLink) => {
    handleToggle(setExpandedDeepLinks, id, deepLinks, ranges.startDate, ranges.endDate, setDeepLinksAnalytics, setIsLoadingAnalytics, openErrorModal, false, setOpenedDeepLink)
    setDateRange(ranges);
};